<div class="image-viewer-container layout-column" [ngStyle]="{'height': height, 'width':height}">
  <div class="image-container flex layout-row layout-align-center-center">

    <bringoz-button type="tertiary"
                    theme="primary"
                    *ngIf="attachments?.length > 1"
                    (onClick)="previousImage()">
      <bringoz-icon iconName="chevron-left" class="carousel-icon"></bringoz-icon>
    </bringoz-button>

    <img *ngIf="currentViewedAttachment" class="flex images"
         [src]="currentViewedAttachment?.mimeType === 'application/pdf'
            ? 'assets/images/empty_state/empty_state_image.png'
            : currentViewedAttachment?.url">

    <img *ngIf="!currentViewedAttachment" class="flex no-img" src="assets/images/upload-image.png">

    <bringoz-button type="tertiary"
                    theme="primary"
                    *ngIf="attachments?.length > 1"
                    (onClick)="nextImage()">
      <bringoz-icon iconName="chevron-right" class="carousel-icon"></bringoz-icon>
    </bringoz-button>

  </div>

  <div *ngIf="attachments.length || canUpload"
       class="layout-row layout-align-start-center bottom-section gap-5">

    <span *ngIf="currentViewedAttachment" class="br-body-2">{{currentViewedAttachment.name}}</span>
    <span class="br-body-2" *ngIf="!!currentViewedAttachment && attachments?.length">
      {{(currentViewedImageIndex + 1) + '/' + (attachments?.length || 0)}}
    </span>
    <span class="flex"></span>

    <bringoz-button type="tertiary"
                    iconName="upload"
                    fill="#266AFF" (onClick)="fileInput.click()">
      <bringoz-icon iconName="upload" fill="#266AFF"></bringoz-icon>
    </bringoz-button>
    <input #fileInput type="file" id="file-upload"/>

    <app-bringoz-file-download-button *ngIf="!!currentViewedAttachment"
                                      [url]="currentViewedAttachment.url"
                                      description="'Download Image'">

    </app-bringoz-file-download-button>

  </div>

</div>
